class VideoElement extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    this.playButton = this.querySelector('[data-play-button]');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.play();
          } else {
            this.video.pause();
          }
        });
      },
      { threshold: 0 }
    );

    this.observer.observe(this.video);

    this.playButton?.addEventListener('click', () => {
      this.video.load();
      this.video
        .play()
        .then(() => this.togglePlayButton())
        .catch(() => {
          this.video.controls = true;
          this.togglePlayButton();
        });
    });
  }

  // play() returns a promise — catch rejection to show play button when autoplay is blocked
  play() {
    const promise = this.video.play();
    if (promise !== undefined) {
      promise.catch(() => {
        this.togglePlayButton();
      });
    }
  }

  togglePlayButton() {
    this.playButton?.classList.toggle('hidden', !this.video.paused);
    this.playButton?.classList.toggle('flex', this.video.paused);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('video-element', VideoElement);
